import React, { useState } from "react";
import classes from "./Assistant.module.css";
import AiLoader from "../Loader/AiLoader";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

function Assistant({
  inputText,
  setInputText,
  responseText,
  setResponseText,
  isLoading,
  setIsLoading,
  loadingText,
  setLoadingText,
  createThread,
}) {
  return (
    <div>
      <AiLoader isLoading={isLoading} text={loadingText} />
      <div className={classes.flexContainer}>
        <div className={classes.textDiv}>
          <TextField
            id="outlined-text"
            label="Text"
            variant="outlined"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            placeholder="Enter your prompt"
            multiline
            rows={2}  
            fullWidth
          />
        </div>
        <div >
          <Button
            variant="contained"
            onClick={createThread}
            disabled={inputText === ""}
          >
            Send
          </Button>
        </div>
      </div>

      {/* <div>
        <h2>Assistant Response:</h2>
        <p>{responseText}</p>
      </div> */}
    </div>
  );
}

export default Assistant;
